import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Plus, Send } from "lucide-react";
import { toast } from "sonner";

export function NovaMensagem({ cats, onCreated }) {
  const [open, setOpen] = useState(false);
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState([]);
  const [evento, setEvento] = useState("");
  const [extra, setExtra] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) api.get("/clients").then((r) => setClients(r.data)).catch(() => {}); }, [open]);
  const list = clients.filter((c) => !q || (c.nome || "").toLowerCase().includes(q.toLowerCase()) || (c.cpf || "").includes(q));
  const toggle = (id) => setSel((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));

  const enviar = async () => {
    if (!evento) { toast.error("Escolha a categoria"); return; }
    if (!sel.length) { toast.error("Selecione ao menos um contato"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/mensagens/nova", { cliente_ids: sel, evento, texto_extra: extra });
      toast.success(`${data.criadas} mensagem(ns) gerada(s)`);
      setOpen(false); setSel([]); setExtra(""); onCreated && onCreated();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao gerar"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-onyx hover:bg-black text-white gap-2" data-testid="msg-nova-btn"><Plus className="w-4 h-4" /> Nova mensagem</Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg" data-testid="msg-nova-dialog">
        <DialogHeader><DialogTitle>Nova mensagem por categoria</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Categoria</Label>
            <Select value={evento} onValueChange={setEvento}>
              <SelectTrigger className="mt-1" data-testid="msg-nova-categoria"><SelectValue placeholder="Selecione..." /></SelectTrigger>
              <SelectContent>{cats.map((c) => <SelectItem key={c.evento} value={c.evento}>{c.titulo}</SelectItem>)}</SelectContent>
            </Select>
            <p className="text-[11px] text-slate-500 mt-1">O texto usa o modelo da categoria (Configurações › Mensagens) com os dados do contrato/parcela em aberto do cliente.</p>
          </div>
          <div>
            <div className="flex items-center justify-between"><Label className="text-xs">Contatos ({sel.length} selecionado(s))</Label>
              <button type="button" className="text-xs gold-text" onClick={() => setSel(sel.length === list.length ? [] : list.map((c) => c.id))} data-testid="msg-nova-todos">{sel.length === list.length && list.length ? "Limpar" : "Selecionar todos"}</button></div>
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nome ou CPF..." className="mt-1" data-testid="msg-nova-busca" />
            <div className="border rounded-lg mt-2 max-h-48 overflow-y-auto slim-scroll divide-y">
              {list.length === 0 && <div className="p-3 text-sm text-slate-400">Nenhum contato.</div>}
              {list.map((c) => (
                <label key={c.id} className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-slate-50">
                  <Checkbox checked={sel.includes(c.id)} onCheckedChange={() => toggle(c.id)} data-testid={`msg-nova-cli-${c.id}`} />
                  <span className="flex-1 truncate">{c.nome}</span>
                  <span className="text-xs text-slate-400">{c.whatsapp || c.telefone || "sem telefone"}</span>
                </label>
              ))}
            </div>
          </div>
          <div><Label className="text-xs">Complemento (opcional)</Label><Textarea rows={2} value={extra} onChange={(e) => setExtra(e.target.value)} className="mt-1 text-sm" placeholder="Texto adicionado ao final da mensagem" data-testid="msg-nova-extra" /></div>
        </div>
        <DialogFooter>
          <Button onClick={enviar} disabled={busy} className="bg-onyx text-white gap-2" data-testid="msg-nova-gerar">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Gerar mensagens</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
